import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import CustomPopupText from '../shared/CustomPopupText';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '30px',
    padding: '8px 8px',
    gap: '16px',
    borderRadius: '8px ',
    background: 'rgb(244, 244, 244)',
  },
}));
const BasicZeroState = ({ text }) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item className={classes.container}>
        <CustomPopupText text={text} />
      </Grid>
    </Grid>
  );
};

export default BasicZeroState;
